// Default width for a search box sitting above a list-page table, per the approved design.
export const DEFAULT_WIDTH_CLASS = "w-[306px]";

export const SEARCH_DEBOUNCE_MS = 300;
